/**
 * 해당 매뉴얼을 열기 위한 함수입니다.
 * @param {string} item - 매뉴얼 파일명
 * @param {string} role - 사용자 역할
 * @returns {void}
 */
export const handleOpenManual = (item, role) => {
  if (item.includes('https')) {
    window.open(`${item}`);
  } else {
    window.open(`/assets/pdf/${role}/${item}`);
  }
};

